// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== 1. Hero Section ===== */
.PortafolioPage_heroSection__jZUna {
  width: 100%;
  position: relative;
  text-align: center;
  padding: 100px 5% 300px 5%;
  color: var(--textoBlanco);
  background-color: #000;
}

.PortafolioPage_heroBackground__7T1\\+F {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.PortafolioPage_heroBackground__7T1\\+F img {
  filter: brightness(50%);
}

.PortafolioPage_heroContent__LJ2nP {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
}

.PortafolioPage_heroSection__jZUna h1 {
  font-size: 52px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.2;
  margin-bottom: 15px;
  padding-top: 6.5%;
}

.PortafolioPage_heroSection__jZUna p {
  font-size: 18px;
  max-width: 600px;
  margin: 0 auto 40px auto;
  color: #ffffff;
  line-height: 1.6;
}

/* ===== Encabezado de la Página ===== */
.PortafolioPage_headerSection__26PqO {
  padding: 5% 5% 0.1px 5%;
  text-align: center;
  background-color: #ffffff; 
}

.PortafolioPage_headerSection__26PqO h1 {
  font-size: 42px;
  font-weight: 800;
  color: var(--textoNegro);
  margin-bottom: 15px;
}

.PortafolioPage_headerSection__26PqO p {
  font-size: 18px;
  color: #555;
  max-width: 700px;
  margin: 0 auto 50px auto;
  line-height: 1.6;
}

/* ===== Navegación de Filtros ===== */
.PortafolioPage_filterNav__Ery9P {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 50px;
}

.PortafolioPage_filterButton__hk4Z5 {
  background-color: #e9e9e9;
  color: #555;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.PortafolioPage_filterButton__hk4Z5:hover {
  background-color: #ddd;
}

.PortafolioPage_filterButtonActive__uoOB6 {
  background-color: var(--naranja);
  color: var(--textoBlanco);
}

/* ===== Cuadrícula de Proyectos ===== */
.PortafolioPage_projectsGridSection__Ox7jx {
  padding: 50px 5% 80px 5%;
}

.PortafolioPage_projectsGrid__mcSwS {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
}

/* ===== Tarjeta de Proyecto Individual ===== */
.PortafolioPage_projectCard__Mk8kN {
  background-color: #f9f9f9;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: box-shadow 0.3s ease;
}
.PortafolioPage_projectCard__Mk8kN:hover {
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
}
.PortafolioPage_imageWrapper__aFxND { overflow: hidden; }
.PortafolioPage_projectImage__wdV2n {
  width: 100%; display: block; aspect-ratio: 16 / 10; object-fit: cover;
  transition: transform 0.4s ease;
}
.PortafolioPage_projectCard__Mk8kN:hover .PortafolioPage_projectImage__wdV2n { transform: scale(1.05); }
.PortafolioPage_cardCaption__xiadK { padding: 25px; text-align: left; }
.PortafolioPage_clientName__Y3eFu {
  font-size: 20px; font-weight: 700; color: var(--textoNegro);
  margin-bottom: 10px;
}
.PortafolioPage_projectDescription__tlX-1 {
  font-size: 16px; color: #555; line-height: 1.6;
  margin-bottom: 20px;
}
.PortafolioPage_viewProjectLink__Ndh\\+V {
  color: var(--azul); font-weight: 600; border: 1px solid var(--azul);
  padding: 8px 16px; border-radius: 5px; display: inline-block;
  transition: all 0.3s ease;
}
.PortafolioPage_viewProjectLink__Ndh\\+V:hover {
  background-color: var(--azul); color: var(--textoBlanco);
}


/* ===== MEDIA QUERY PARA MÓVILES ===== */
@media (max-width: 767px) {
  .PortafolioPage_headerSection__26PqO h1 { font-size: 32px; }
  .PortafolioPage_projectsGrid__mcSwS {
    grid-template-columns: 1fr; 
  }
}

/* ====== Videos Section ====== */
.PortafolioPage_videosSection__5p4bK {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 72px 20px;
}

.PortafolioPage_videosHeader__43eQT {
  text-align: center;
  margin-bottom: 28px;
}

.PortafolioPage_videosTitle__WLhMU {
  font-size: clamp(1.6rem, 2.2vw, 2.2rem);
  line-height: 1.1;
  margin: 0 0 10px 0;
   font-weight: 800;
  text-align: center;
  color: var(--textoNegro);
  
}

.PortafolioPage_videosSubtitle__BvO17 {
  margin: 0 auto;
  max-width: 720px;
  opacity: 0.85;
  font-size: 1rem;
  line-height: 1.5;
}

.PortafolioPage_videosGrid__TYMnS {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 22px;
}

.PortafolioPage_videoCard__kCV6L {
  border-radius: 18px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: transform 180ms ease, border-color 180ms ease;
}

.PortafolioPage_videoCard__kCV6L:hover {
  transform: translateY(-3px);
  border-color: rgba(255, 255, 255, 0.18);
}

/* Wrapper responsive 16:9 */
.PortafolioPage_videoFrame__WUa3a {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
 
}

.PortafolioPage_videoFrame__WUa3a iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.PortafolioPage_videoMeta__bteQJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 14px 16px 14px;
}

.PortafolioPage_videoName__AdJ2h {
  margin: 0;
  font-size: 0.98rem;
  line-height: 1.2;
  opacity: 0.95;
}

.PortafolioPage_videoLink__D-i7s {
  font-size: 0.92rem;
  text-decoration: none;
  opacity: 0.9;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  padding-bottom: 2px;
  transition: opacity 180ms ease, border-color 180ms ease;
}

.PortafolioPage_videoLink__D-i7s:hover {
  opacity: 1;
  border-color: rgba(255, 255, 255, 0.55);
}

/* Responsive */
@media (max-width: 900px) {
  .PortafolioPage_videosGrid__TYMnS {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .PortafolioPage_videosSection__5p4bK {
    padding: 54px 16px;
  }

  .PortafolioPage_videosGrid__TYMnS {
    grid-template-columns: 1fr;
  }

  .PortafolioPage_videoMeta__bteQJ {
    flex-direction: column;
    align-items: flex-start;
  }
}


/* ====== Banners Section ====== */
.PortafolioPage_bannersSection__uiBnL {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 54px 20px 80px;
}

.PortafolioPage_bannersHeader__9i8TW {
  text-align: center;
  margin-bottom: 26px;
}

.PortafolioPage_bannersTitle__QMW7f {
  font-size: clamp(1.5rem, 2vw, 2.1rem);
  font-weight: 800;
  text-align: center;
  color: var(--textoNegro);
  margin-bottom: 60px;
  margin: 0 0 10px 0;
}

.PortafolioPage_bannersSubtitle__oKiwH {
  margin: 0 auto;
  max-width: 760px;
  opacity: 0.85;
  font-size: 1rem;
  line-height: 1.5;
}

.PortafolioPage_bannersGrid__lxV4q {
  display: grid;
  grid-template-columns: 1fr; /* 1 por fila (se ven grandes) */
  gap: 18px;
}

.PortafolioPage_bannerCard__Lj7ij {
  margin: 0;
  border-radius: 18px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform 180ms ease, border-color 180ms ease;
}

.PortafolioPage_bannerCard__Lj7ij:hover {
  transform: translateY(-3px);
  border-color: rgba(255, 255, 255, 0.18);
}

/* Mantiene ratio 1928x500 (~3.856:1) */
.PortafolioPage_bannerFrame__epDqw {
  width: 100%;
  aspect-ratio: 1928 / 500;
  background: rgba(0, 0, 0, 0.25);
}

.PortafolioPage_bannerFrame__epDqw img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* llena sin deformar */
  display: block;
}

/* Si quieres 2 banners por fila en pantallas MUY grandes */
@media (min-width: 1280px) {
  .PortafolioPage_bannersGrid__lxV4q {
    grid-template-columns: 1fr; /* déjalo en 1 si los quieres enormes */
  }
}

@media (max-width: 640px) {
  .PortafolioPage_bannersSection__uiBnL {
    padding: 44px 16px 64px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PortafolioPage.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,gCAAgC;AAClC;AACA;EACE,sCAAsC;AACxC;AACA,sCAAgB,gBAAgB,EAAE;AAClC;EACE,WAAW,EAAE,cAAc,EAAE,qBAAqB,EAAE,iBAAiB;EACrE,+BAA+B;AACjC;AACA,+EAAmC,sBAAsB,EAAE;AAC3D,qCAAe,aAAa,EAAE,gBAAgB,EAAE;AAChD;EACE,eAAe,EAAE,gBAAgB,EAAE,wBAAwB;EAC3D,mBAAmB;AACrB;AACA;EACE,eAAe,EAAE,WAAW,EAAE,gBAAgB;EAC9C,mBAAmB;AACrB;AACA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,6BAA6B;EACnE,iBAAiB,EAAE,kBAAkB,EAAE,qBAAqB;EAC5D,yBAAyB;AAC3B;AACA;EACE,6BAA6B,EAAE,yBAAyB;AAC1D;;;AAGA,yCAAyC;AACzC;EACE,0CAAoB,eAAe,EAAE;EACrC;IACE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;GACjB,gBAAgB;EACjB,kBAAkB;EAClB,wBAAwB;;AAE1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,kDAAkD;EAClD,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;;AAGA,kCAAkC;AAClC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B,EAAE,gCAAgC;EAC5D,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,uBAAuB;EAC1C,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE;IACE,0BAA0B,EAAE,uCAAuC;EACrE;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ===== 1. Hero Section ===== */\n.heroSection {\n  width: 100%;\n  position: relative;\n  text-align: center;\n  padding: 100px 5% 300px 5%;\n  color: var(--textoBlanco);\n  background-color: #000;\n}\n\n.heroBackground {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n}\n\n.heroBackground img {\n  filter: brightness(50%);\n}\n\n.heroContent {\n  position: relative;\n  z-index: 2;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.heroSection h1 {\n  font-size: 52px;\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1.2;\n  margin-bottom: 15px;\n  padding-top: 6.5%;\n}\n\n.heroSection p {\n  font-size: 18px;\n  max-width: 600px;\n  margin: 0 auto 40px auto;\n  color: #ffffff;\n  line-height: 1.6;\n}\n\n/* ===== Encabezado de la Página ===== */\n.headerSection {\n  padding: 5% 5% 0.1px 5%;\n  text-align: center;\n  background-color: #ffffff; \n}\n\n.headerSection h1 {\n  font-size: 42px;\n  font-weight: 800;\n  color: var(--textoNegro);\n  margin-bottom: 15px;\n}\n\n.headerSection p {\n  font-size: 18px;\n  color: #555;\n  max-width: 700px;\n  margin: 0 auto 50px auto;\n  line-height: 1.6;\n}\n\n/* ===== Navegación de Filtros ===== */\n.filterNav {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-bottom: 50px;\n}\n\n.filterButton {\n  background-color: #e9e9e9;\n  color: #555;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.filterButton:hover {\n  background-color: #ddd;\n}\n\n.filterButtonActive {\n  background-color: var(--naranja);\n  color: var(--textoBlanco);\n}\n\n/* ===== Cuadrícula de Proyectos ===== */\n.projectsGridSection {\n  padding: 50px 5% 80px 5%;\n}\n\n.projectsGrid {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 40px;\n}\n\n/* ===== Tarjeta de Proyecto Individual ===== */\n.projectCard {\n  background-color: #f9f9f9;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.05);\n  transition: box-shadow 0.3s ease;\n}\n.projectCard:hover {\n  box-shadow: 0 8px 25px rgba(0,0,0,0.1);\n}\n.imageWrapper { overflow: hidden; }\n.projectImage {\n  width: 100%; display: block; aspect-ratio: 16 / 10; object-fit: cover;\n  transition: transform 0.4s ease;\n}\n.projectCard:hover .projectImage { transform: scale(1.05); }\n.cardCaption { padding: 25px; text-align: left; }\n.clientName {\n  font-size: 20px; font-weight: 700; color: var(--textoNegro);\n  margin-bottom: 10px;\n}\n.projectDescription {\n  font-size: 16px; color: #555; line-height: 1.6;\n  margin-bottom: 20px;\n}\n.viewProjectLink {\n  color: var(--azul); font-weight: 600; border: 1px solid var(--azul);\n  padding: 8px 16px; border-radius: 5px; display: inline-block;\n  transition: all 0.3s ease;\n}\n.viewProjectLink:hover {\n  background-color: var(--azul); color: var(--textoBlanco);\n}\n\n\n/* ===== MEDIA QUERY PARA MÓVILES ===== */\n@media (max-width: 767px) {\n  .headerSection h1 { font-size: 32px; }\n  .projectsGrid {\n    grid-template-columns: 1fr; \n  }\n}\n\n/* ====== Videos Section ====== */\n.videosSection {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 72px 20px;\n}\n\n.videosHeader {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.videosTitle {\n  font-size: clamp(1.6rem, 2.2vw, 2.2rem);\n  line-height: 1.1;\n  margin: 0 0 10px 0;\n   font-weight: 800;\n  text-align: center;\n  color: var(--textoNegro);\n  \n}\n\n.videosSubtitle {\n  margin: 0 auto;\n  max-width: 720px;\n  opacity: 0.85;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.videosGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 22px;\n}\n\n.videoCard {\n  border-radius: 18px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  transition: transform 180ms ease, border-color 180ms ease;\n}\n\n.videoCard:hover {\n  transform: translateY(-3px);\n  border-color: rgba(255, 255, 255, 0.18);\n}\n\n/* Wrapper responsive 16:9 */\n.videoFrame {\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%;\n \n}\n\n.videoFrame iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.videoMeta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 14px 16px 14px;\n}\n\n.videoName {\n  margin: 0;\n  font-size: 0.98rem;\n  line-height: 1.2;\n  opacity: 0.95;\n}\n\n.videoLink {\n  font-size: 0.92rem;\n  text-decoration: none;\n  opacity: 0.9;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n  padding-bottom: 2px;\n  transition: opacity 180ms ease, border-color 180ms ease;\n}\n\n.videoLink:hover {\n  opacity: 1;\n  border-color: rgba(255, 255, 255, 0.55);\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .videosGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .videosSection {\n    padding: 54px 16px;\n  }\n\n  .videosGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .videoMeta {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n\n/* ====== Banners Section ====== */\n.bannersSection {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 54px 20px 80px;\n}\n\n.bannersHeader {\n  text-align: center;\n  margin-bottom: 26px;\n}\n\n.bannersTitle {\n  font-size: clamp(1.5rem, 2vw, 2.1rem);\n  font-weight: 800;\n  text-align: center;\n  color: var(--textoNegro);\n  margin-bottom: 60px;\n  margin: 0 0 10px 0;\n}\n\n.bannersSubtitle {\n  margin: 0 auto;\n  max-width: 760px;\n  opacity: 0.85;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.bannersGrid {\n  display: grid;\n  grid-template-columns: 1fr; /* 1 por fila (se ven grandes) */\n  gap: 18px;\n}\n\n.bannerCard {\n  margin: 0;\n  border-radius: 18px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: transform 180ms ease, border-color 180ms ease;\n}\n\n.bannerCard:hover {\n  transform: translateY(-3px);\n  border-color: rgba(255, 255, 255, 0.18);\n}\n\n/* Mantiene ratio 1928x500 (~3.856:1) */\n.bannerFrame {\n  width: 100%;\n  aspect-ratio: 1928 / 500;\n  background: rgba(0, 0, 0, 0.25);\n}\n\n.bannerFrame img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* llena sin deformar */\n  display: block;\n}\n\n/* Si quieres 2 banners por fila en pantallas MUY grandes */\n@media (min-width: 1280px) {\n  .bannersGrid {\n    grid-template-columns: 1fr; /* déjalo en 1 si los quieres enormes */\n  }\n}\n\n@media (max-width: 640px) {\n  .bannersSection {\n    padding: 44px 16px 64px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroSection": `PortafolioPage_heroSection__jZUna`,
	"heroBackground": `PortafolioPage_heroBackground__7T1+F`,
	"heroContent": `PortafolioPage_heroContent__LJ2nP`,
	"headerSection": `PortafolioPage_headerSection__26PqO`,
	"filterNav": `PortafolioPage_filterNav__Ery9P`,
	"filterButton": `PortafolioPage_filterButton__hk4Z5`,
	"filterButtonActive": `PortafolioPage_filterButtonActive__uoOB6`,
	"projectsGridSection": `PortafolioPage_projectsGridSection__Ox7jx`,
	"projectsGrid": `PortafolioPage_projectsGrid__mcSwS`,
	"projectCard": `PortafolioPage_projectCard__Mk8kN`,
	"imageWrapper": `PortafolioPage_imageWrapper__aFxND`,
	"projectImage": `PortafolioPage_projectImage__wdV2n`,
	"cardCaption": `PortafolioPage_cardCaption__xiadK`,
	"clientName": `PortafolioPage_clientName__Y3eFu`,
	"projectDescription": `PortafolioPage_projectDescription__tlX-1`,
	"viewProjectLink": `PortafolioPage_viewProjectLink__Ndh+V`,
	"videosSection": `PortafolioPage_videosSection__5p4bK`,
	"videosHeader": `PortafolioPage_videosHeader__43eQT`,
	"videosTitle": `PortafolioPage_videosTitle__WLhMU`,
	"videosSubtitle": `PortafolioPage_videosSubtitle__BvO17`,
	"videosGrid": `PortafolioPage_videosGrid__TYMnS`,
	"videoCard": `PortafolioPage_videoCard__kCV6L`,
	"videoFrame": `PortafolioPage_videoFrame__WUa3a`,
	"videoMeta": `PortafolioPage_videoMeta__bteQJ`,
	"videoName": `PortafolioPage_videoName__AdJ2h`,
	"videoLink": `PortafolioPage_videoLink__D-i7s`,
	"bannersSection": `PortafolioPage_bannersSection__uiBnL`,
	"bannersHeader": `PortafolioPage_bannersHeader__9i8TW`,
	"bannersTitle": `PortafolioPage_bannersTitle__QMW7f`,
	"bannersSubtitle": `PortafolioPage_bannersSubtitle__oKiwH`,
	"bannersGrid": `PortafolioPage_bannersGrid__lxV4q`,
	"bannerCard": `PortafolioPage_bannerCard__Lj7ij`,
	"bannerFrame": `PortafolioPage_bannerFrame__epDqw`
};
export default ___CSS_LOADER_EXPORT___;
